import Vue from 'vue'
import VueApollo from 'vue-apollo'
import { VueMasonryPlugin } from 'vue-masonry'

import 'shared-icons'

import '@shared/plugins/element'
import i18n from '@shared/i18n-utils/i18n.vue'
import fileUpload from '@shared/form/file-upload.vue'
import addressPartial from '@shared/form/address.vue'
import phoneInput from '@shared/form/phone-input.vue'

import elTextarea from '@shared/form/el-textarea.vue'

import { parseDateModel } from '@/filters/date'

import '@/error-tracking'
import router from '@/router'
import store from '@/store'

import graphQLClient from '@/graphql/client'

import App from '@/App.vue'

Vue.config.productionTip = false

Vue.use(VueApollo)
Vue.use(VueMasonryPlugin)

Vue.component('app-i18n', i18n)
Vue.component('app-file-upload', fileUpload)
Vue.component('app-address-form-partial', addressPartial)
Vue.component('app-phone-input', phoneInput)
Vue.component('el-textarea', elTextarea)

Vue.filter('parseDateModel', parseDateModel)

const apolloProvider = new VueApollo({
  defaultClient: graphQLClient,
})

export default new Vue({
  router,
  store,
  apolloProvider,
  render: h => h(App),
}).$mount('#app')
